import React, { createContext, useContext, useState, useEffect } from 'react'

const AuthContext = createContext()

function AuthProvider({ children }) {
  const [user, setUser] = useState(null)

  useEffect(() => {
    console.log("AUTENTICADO");
    const userStorage = localStorage.getItem('user');
    if (userStorage && userStorage !== "undefined" && userStorage !== null) {
      const storedUser = JSON.parse(userStorage);
      setUser(storedUser);
    }
  }, [])

  const getUser = () => {
    const userStorage = localStorage.getItem('user');
    if (userStorage && userStorage !== "undefined" && userStorage !== null) {
      const storedUser = JSON.parse(userStorage);
      return storedUser;
    }
    return {};
  }

  const userIsAuthenticated = () => {
    console.log("AUTENTICADO");
    let storedUser = localStorage.getItem('user')
    if (!storedUser) {
      return false
    }
    if (storedUser && storedUser !== "undefined" && storedUser !== null) {
      storedUser = JSON.parse(storedUser)
  
      // if user has token expired, logout user
      if (Date.now() > storedUser.data.exp * 1000) {
        userLogout()
        return false
      }

    }
    return true
  }

  const userLogin = user => {
    localStorage.setItem('user', JSON.stringify(user))
    setUser(user)
  }

  const userLogout = () => {
    localStorage.removeItem('user')
    setUser(null)
  }

  const contextValue = {
    user,
    getUser,
    userIsAuthenticated,
    userLogin,
    userLogout,
  }

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext

export function useAuth() {
  return useContext(AuthContext)
}

export { AuthProvider }